import React, { Component } from "react";
import "react-bootstrap";
import { connect } from "react-redux";
import $ from "jquery/dist/jquery.js";

import store from "../../store/configureStore";
import InformationSlider from "./Information/InformationSlider";
import { changeActiveItemAction } from "../../actions/navAction";
import {
  changeTopBannerAction,
  setBusinessAction,
} from "../../actions/topBannerAction";
import { Businesses, PagesForCaption, CaptionCodes } from "../../config/Helper";
import NewsSection from "./News/NewsSection";
import TestimonialSection from "./Testimonial/TestimonialSection";
import PhotoArticleSection from "./PhotoArticle/PhotoArticleSection";
import AgencySlider from "../../components/agency/AgencySlider";
import Ads from "./Ads";
import RightBar from "./RightBar/RightBar";
import captionApi from "../../api/captionApi";

import { changeHomeSectionAction } from "../../actions/homeSectionAction";
import { addNotification } from "../../actions/notificationAction";
import { lang } from "../../config/lang";
import mediaApi from "../../api/mediaApi";
import blogApi from "../../api/blogApi";
import destinationApi from "../../api/destinationApi";
import { stepAlarmEditStyle } from "../../config/style";
import Modal from "react-modal";
import AlarmBlock from "./AlarmBlock";
import AlarmArticleBlock from "./AlarmArticleBlock";
import { Link } from "react-router-dom";
import DestinationAreaListBlock from "../destination/list/DestinationAreaListBlock";
import MediaBlock from "../portfolio/MediaBlock";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionTitle: {},
      contentModalIsOpen: true,
      arrAlarmVideo: [],
      arrAlarmPhoto: [],
      arrAlarmArticle: [],
      arrArticle: [],
      destinationArray: [],
      captionTitle: [],
      arrServicedata: [],
      arrPlacedata: [],
    };
    this.business = Businesses.indexOf("destination");
    this.isInited = sessionStorage.getItem("isInited");
    this.showFooter = this.showFooter.bind(this);
    this.showFooterBar = this.showFooterBar.bind(this);
    this.getSectionTitles = this.getSectionTitles.bind(this);
    this.closeContentModal = this.closeContentModal.bind(this);
    this.getMedias = this.getMedias.bind(this);
    this.getCaptions = this.getCaptions.bind(this);
    this.goToPortfolio = this.goToPortfolio.bind(this);
  }

  componentWillMount() {
    store.dispatch(changeActiveItemAction(Businesses.indexOf("home")));
    store.dispatch(
      changeTopBannerAction({
        page: "home",
        showSearch: false,
        isHome: true,
      })
    );
  }

  componentDidMount() {
    this.getSectionTitles();
    this.showFooter(false);
    window.onSetClass("light");
    window.onClose();
    window.scrollTop("#top_banner");
    window.contentWayPoint();
    setTimeout(this.showFooterBar, 800);
    this.getMedias(true);
  }

  componentDidUpdate() {
    this.isInited = sessionStorage.getItem("isInited");
    window.onClose();
  }

  componentWillUnmount() {}

  componentWillReceiveProps(newProps) {
    this.getSectionTitles();
    if (this.props.language.lang_key !== newProps.language.lang_key) {
      this.getMedias(false);
    }
  }

  showFooter(willShow) {
    $("#footer").css("visibility", willShow ? "visible" : "hidden");
  }

  showFooterBar() {
    this.showFooter(true);
  }

  getSectionTitles() {
    captionApi.getCaptions("home").then((json) => {
      if (json.status === 200) {
        this.setState({
          sectionTitle: json.data,
        });
      } else {
        // store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
      }
    });
  }
  getMedias(willGoList) {
    mediaApi.paginate("1", "news", "video", "", 6).then((json) => {
      if (json.status === 200) {
        // this.paginate.currentPage = json.data.currentPage;
        // this.paginate.lastPage = json.data.lastPage;
        // const medias = Array.isArray(json.data.data) ? json.data.data : [];

        this.setState({
          arrAlarmVideo:
            json.data.data.length > 3
              ? json.data.data.slice(0, 2)
              : json.data.data,
        });

        window.contentWayPoint();
        willGoList && window.scrollTop("#mediaListSection");
      } else {
        store.dispatch(addNotification("Server error", "error"));
      }
    });
    mediaApi.paginate("1", "news", "image", "", 6).then((json) => {
      if (json.status === 200) {
        this.setState({
          arrAlarmPhoto:
            json.data.data.length > 3
              ? json.data.data.slice(0, 2)
              : json.data.data,
        });

        window.contentWayPoint();
        willGoList && window.scrollTop("#mediaListSection");
      } else {
        store.dispatch(addNotification("Server error", "error"));
      }
    });
    mediaApi.paginate("1", "service", "", "", 6).then((json) => {
      if (json.status === 200) {
        this.setState({
          arrServicedata:
            json.data.data.length > 4
              ? json.data.data.slice(0, 4)
              : json.data.data,
        });

        window.contentWayPoint();
        willGoList && window.scrollTop("#mediaListSection");
      } else {
        store.dispatch(addNotification("Server error", "error"));
      }
    });
    mediaApi.paginate("1", "place", "", "", 6).then((json) => {
      if (json.status === 200) {
        this.setState({
          arrPlacedata:
            json.data.data.length > 4
              ? json.data.data.slice(0, 4)
              : json.data.data,
        });

        window.contentWayPoint();
        willGoList && window.scrollTop("#mediaListSection");
      } else {
        store.dispatch(addNotification("Server error", "error"));
      }
    });
    blogApi.getBlogsWithPage("1", "news", "", "", "o", "", 6).then((json) => {
      let arryArticleTemp = [];
      if (json.status === 200) {
        this.isLoading = false;

        json.data.data.length &&
          json.data.data.map((article, index) =>
            article.media_filetype != 1 && article.media_filetype != 0
              ? arryArticleTemp.push(article)
              : ""
          );
        this.setState({
          arrAlarmArticle: json.data.data,
          arrArticle:
            arryArticleTemp.length > 3
              ? arryArticleTemp.slice(0, 2)
              : arryArticleTemp,
        });
        window.contentWayPoint();
        willGoList && window.scrollTop("#blog_main_section");
      } else {
        store.dispatch(addNotification(`${lang("server_err")}`, "error"));
      }
    });
    destinationApi.getDestinationArea(0).then((json) => {
      if (json.status === 200 && json.data) {
        this.isloading = false;
        // eslint-disable-next-line
        this.state.destinationArray =
          json.data.destinations.length > 3
            ? json.data.destinations.slice(0, 4)
            : json.data.destinations;
        this.getCaptions();
      } else {
        if (json.status === 620) {
        } else {
        }
      }
    });
    // store.dispatch(changeActiveItemAction(Businesses.indexOf('destination')));
  }
  getCaptions() {
    captionApi.getCaptions("destinations").then((json) => {
      if (json.status === 200) {
        this.setState({
          captionTitle: json.data,
        });
      } else {
      }
    });
  }
  closeContentModal() {
    this.setState({
      modal_info: {},
      contentModalIsOpen: false,
    });
  }

  goToPortfolio(business) {
    store.dispatch(setBusinessAction(business));
    this.props.history.push("/portfolio");
  }

  render() {
    return (
      <div className="home-page">
        <RightBar sectionTitle={this.state.sectionTitle} />
        <section className="ftco-section bg-light" id="destinationListSection">
          <div className="container">
            <div className="row justify-content-center mb-5 pb-3">
              <div className="col-md-7 heading-section text-center">
                <h2 className="mb-4">
                  {this.state.captionTitle[
                    CaptionCodes[
                      PagesForCaption.indexOf("destinations")
                    ].indexOf("destinations_destination")
                  ] === undefined
                    ? ""
                    : this.state.captionTitle[
                        CaptionCodes[
                          PagesForCaption.indexOf("destinations")
                        ].indexOf("destinations_destination")
                      ].title}
                </h2>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              {this.state.destinationArray.map((destination, key) => (
                <div
                  key={key}
                  className="col-12 col-sm-3 col-md-3 col-lg-3 ftco-animate fadeInUp ftco-animated"
                >
                  <DestinationAreaListBlock
                    id={destination.id}
                    image={destination.media_filename}
                    title={destination.title}
                    business={this.business}
                    media_type={destination.media_filetype}
                    cat="destination"
                  />
                </div>
              ))}
              <div className="col-md-12 animate-box text-center mt-3">
                <Link
                  to={`/destination/`}
                  className="btn btn-primary btn-outline-primary"
                >
                  {lang("view_all")}
                  <i className="ion-ios-arrow-forward"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="ftco-section" id="serviceListSection">
                    <div className="container">
                        <div className="row justify-content-center mb-5 pb-3">
                            <div className="col-md-7 heading-section text-center">
                                <h2 className="mb-4">
                                    {lang("service")}
                                </h2></div>
                        </div>
                    </div> */}
        {/* <div className="container">
                        <div className="row">
                            <div className="col-lg-12 pr-lg-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        {
                                            this.state.arrServicedata &&
                                            this.state.arrServicedata.map((media, key) => (
                                                <div className="post-box col-12 col-sm-6 col-md-4 col-lg-3 ftco-animate" data-animate-effect="fadeIn" key={key}>
                                                    <MediaBlock
                                                        business={media.business}
                                                        id={media.business_id}
                                                        title={media.title}
                                                        image={media.name}
                                                        media_type={media.format} />
                                                </div>

                                            ))
                                        }
                                        <div className="col-md-12 animate-box text-center mt-3">
                                        <button className="btn btn-primary btn-outline-primary" onClick={() => this.goToPortfolio('service')}>{lang('view_all')}<i className="ion-ios-arrow-forward"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
        {/* </section> */}
        <section className="ftco-section" id="serviceListSection">
          <div className="container">
            <div className="row justify-content-center mb-5 pb-3">
              <div className="col-md-7 heading-section text-center">
                <h2 className="mb-4">{lang("service")}</h2>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 pr-lg-4">
                <div className="row">
                  <div className="col-md-12">
                    {this.state.arrServicedata &&
                      this.state.arrServicedata.map((media, key) => (
                        <div
                          className="post-box col-12 col-sm-6 col-md-4 col-lg-3 ftco-animate"
                          data-animate-effect="fadeIn"
                          key={key}
                        >
                          <MediaBlock
                            business={media.business}
                            id={media.business_id}
                            title={media.title}
                            image={media.name}
                            media_type={media.format}
                          />
                        </div>
                      ))}
                    <div className="col-md-12 animate-box text-center mt-3">
                      <button
                        className="btn btn-primary btn-outline-primary"
                        onClick={() => this.goToPortfolio("service")}
                      >
                        {lang("view_all")}
                        <i className="ion-ios-arrow-forward"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ftco-section" id="placeListSection">
          <div className="container">
            <div className="row justify-content-center mb-5 pb-3">
              <div className="col-md-7 heading-section text-center">
                <h2 className="mb-4">{lang("place")}</h2>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 pr-lg-4">
                <div className="row">
                  <div className="col-md-12">
                    {this.state.arrPlacedata &&
                      this.state.arrPlacedata.map((media, key) => (
                        <div
                          className="post-box col-12 col-sm-6 col-md-4 col-lg-3 ftco-animate"
                          data-animate-effect="fadeIn"
                          key={key}
                        >
                          <DestinationAreaListBlock
                            id={media.business_id}
                            image={media.name}
                            title={media.title}
                            business={media.business}
                            media_type={media.format}
                            cat="place"
                          />
                          {/* <MediaBlock
                                                        business={media.business}
                                                        id={media.business_id}
                                                        title={media.title}
                                                        image={media.name}
                                                        media_type={media.format} /> */}
                        </div>
                      ))}
                    <div className="col-md-12 animate-box text-center mt-3">
                      <button
                        className="btn btn-primary btn-outline-primary"
                        onClick={() => this.goToPortfolio("place")}
                      >
                        {lang("view_all")}
                        <i className="ion-ios-arrow-forward"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <TestimonialSection
          title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_testimony"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_testimony"
                  )
                ].title
          }
          sub_title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_testimony"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_testimony"
                  )
                ].description
          }
        />

        <AgencySlider
          isPart={true}
          title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_agency"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_agency"
                  )
                ].title
          }
          sub_title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_agency"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_agency"
                  )
                ].description
          }
        />

        <InformationSlider
          title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_information"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_information"
                  )
                ].title
          }
          sub_title={
            this.state.sectionTitle[
              CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                "home_information"
              )
            ] === undefined
              ? ""
              : this.state.sectionTitle[
                  CaptionCodes[PagesForCaption.indexOf("home")].indexOf(
                    "home_information"
                  )
                ].description
          }
        />
        {/* {(this.isInited === undefined || this.isInited === null) && ( */}
        <Ads />
        {/* )} */}
        <Modal
          isOpen={this.state.contentModalIsOpen}
          onAfterOpen={this.afterContentModal}
          onRequestClose={this.closeContentModal}
          style={stepAlarmEditStyle}
          ariaHideApp={false}
        >
          <div className="custom-modal-header has-back news">
            <button
              type="button"
              className="close pull-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => this.closeContentModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h3 className="title">{lang("news")}</h3>
          </div>
          <div className="container">
            <div style={{ marginTop: "100px" }}>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {this.state.arrAlarmVideo.map((news, key) => (
                    <div
                      key={key}
                      style={{
                        marginLeft: "10px",
                        width: "300px",
                      }}
                      data-lightbox="gallery"
                    >
                      <AlarmBlock
                        key={key}
                        business={news.business}
                        id={news.business_id}
                        title={news.title}
                        description={news.description}
                        created_at={news.created_at}
                        image={news.name}
                        media_type={news.format}
                        isNew={news.isNew}
                      />
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    marginLeft: "10px",
                  }}
                  data-lightbox="gallery"
                >
                  {this.state.arrAlarmPhoto.map((news, key) => (
                    <div
                      style={{
                        marginLeft: "5px",
                        width: "300px",
                      }}
                      key={key}
                    >
                      <AlarmBlock
                        key={key}
                        business={news.business}
                        id={news.business_id}
                        title={news.title}
                        description={news.description}
                        created_at={news.created_at}
                        image={news.name}
                        media_type={news.format}
                        isNew={news.isNew}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div>
                {this.state.arrArticle.map((news, key) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                    key={key}
                  >
                    <AlarmArticleBlock
                      key={key}
                      business={news.business}
                      id={news.id}
                      title={news.title}
                      description={news.description}
                      created_at={news.created_at}
                      image={news.media_filename}
                      media_type={news.media_filetype}
                      isNew={news.isNew}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(Home);
